module.exports = __webpack_public_path__ + "img/mk.c57ec437.png";